import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'siat-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss'],
   
  imports: [CommonModule],
})
export class DownloadButtonComponent {
  /**
   * The attribute aria label
   */
  @Input() ariaLabel: string;

  /**
   * A boolean It tells if the button is disabled or not.
   */
  @Input() isDisabled: boolean;

  /**
   * The input label.
   */
  @Input() label: string;

  /**
   * On click download event emitter.
   */
  @Output()
  clickDownloadButtonEvent = new EventEmitter();

  /**
   * The click event of the button.
   */
  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.isDisabled) return;

    this.clickDownloadButtonEvent.emit();
  }
}
